import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { FormControl, FormControlProps, FormLabel, Select } from '@tq/ui-components';
import { ComponentWithAs } from '@tq/ui-components/dist/system';

import { searchViewTypeState } from 'store';
import { ConsultationViewTypes, ValueLabelResponse } from 'types';

export const ConsultationViewType: ComponentWithAs<'div', FormControlProps> = (props) => {
  const { t } = useTranslation('search_filter');
  const viewFilterItems: ValueLabelResponse[] = [
    {
      value: ConsultationViewTypes.Open,
      label: t('open_consultations', 'Open consultations'),
    },
    {
      value: ConsultationViewTypes.Archived,
      label: t('archived_consultations', 'Archived consultations'),
    },
  ];
  const [viewType, setViewType] = useRecoilState(searchViewTypeState);

  return (
    <FormControl {...props}>
      <FormLabel id='view_type_label'>{t('view_title', 'View')}</FormLabel>
      <Select
        aria-labelledby='view_type_label'
        data-testid='view-filter'
        mr={1}
        placeholder={`- ${t('select', 'Select')} -`}
        width='100%'
        value={viewType.toString()}
        onChange={(value: string) => setViewType(+value)}
        menuZIndex={1}
      >
        {viewFilterItems.map((filter) => (
          <option key={filter.value} value={filter.value.toString()}>
            {filter.label}
          </option>
        ))}
      </Select>
    </FormControl>
  );
};
